import { createFrontendModule } from '@backstage/frontend-plugin-api';
import {
  HomePageLayoutBlueprint,
  HomePageWidgetBlueprint,
} from '@backstage/plugin-home-react/alpha';

const portalWelcomeWidget = HomePageWidgetBlueprint.make({
  name: 'portal-welcome',
  params: {
    components: () =>
      import('./widgets/welcome-widget/welcome-widget').then(module => ({
        Content: module.WelcomeWidget,
        Renderer: module.WelcomeWidgetCard,
      })),
    description: 'Search the portal or browse the full software catalog.',
    name: 'PortalWelcome',
    title: 'Hi, how can we help?',
  },
});

const portalMissionWidget = HomePageWidgetBlueprint.make({
  name: 'portal-mission',
  params: {
    components: () =>
      import('./widgets/mission-widget/mission-widget').then(module => ({
        Content: module.MissionWidget,
        Renderer: module.MissionWidgetCard,
      })),
    description: 'The purpose of the portal and how to get support.',
    name: 'PortalMission',
    title: 'Portal mission',
  },
});

const workspacesWidget = HomePageWidgetBlueprint.make({
  name: 'workspaces',
  params: {
    components: () =>
      import('./widgets/workspace-widget/workspace-widget').then(module => ({
        Content: module.WorkspaceWidget,
        Renderer: module.WorkspaceWidgetCard,
      })),
    description: 'View your workspaces or request a new one.',
    name: 'Workspaces',
    title: 'My workspaces',
  },
});

const licensesWidget = HomePageWidgetBlueprint.make({
  name: 'licenses',
  params: {
    components: async () => {
      const [content, renderer] = await Promise.all([
        import('@ns/plugin-ns-tessa-user-licenses/current-user-licenses'),
        import('./widgets/licenses-widget/licenses-widget'),
      ]);
      return {
        Content: content.CurrentUserLicenses,
        Renderer: renderer.LicensesWidgetCard,
      };
    },
    description: 'Your current active license(s).',
    name: 'Licenses',
    title: 'My licenses',
  },
});

const techRadarsWidget = HomePageWidgetBlueprint.make({
  name: 'tech-radars',
  params: {
    components: () =>
      import('./widgets/tech-radars-widget/tech-radars-widget').then(
        module => ({
          Content: module.TechRadarsWidget,
          Renderer: module.TechRadarsWidgetCard,
        }),
      ),
    description: 'Technology choices and lifecycle status.',
    name: 'TechRadars',
    title: 'Tech radars',
  },
});

const devJourneysWidget = HomePageWidgetBlueprint.make({
  name: 'dev-journeys',
  params: {
    components: () =>
      import('./widgets/dev-journeys-widget/dev-journeys-widget').then(
        module => ({
          Content: module.DevJourneysWidget,
          Renderer: module.DevJourneysWidgetCard,
        }),
      ),
    description: 'Guidance for getting software to production.',
    name: 'DevJourneys',
    title: 'Dev journeys guide',
  },
});

const portalHomeLayout = HomePageLayoutBlueprint.make({
  params: {
    loader: () =>
      import('./components/home-layout/home-layout').then(
        module => module.HomeLayout,
      ),
  },
});

/** NS widgets and read-only layout for the official Home plugin. */
export const homeModuleDashboard = createFrontendModule({
  extensions: [
    portalWelcomeWidget,
    portalMissionWidget,
    workspacesWidget,
    licensesWidget,
    techRadarsWidget,
    devJourneysWidget,
    portalHomeLayout,
  ],
  pluginId: 'home',
});
